import {
    GET_LIST_CARD_ISSUED_COUNT,
    REMOVE_CARD_ISSUED_COUNT
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    card_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_CARD_ISSUED_COUNT: {
            return {
                ...state,
                card_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }

        case REMOVE_CARD_ISSUED_COUNT: {
            let temp = state.card_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, card_list: temp }
        }
        default: return { ...state };
    }
}
